"use strict";

var _ = require('lodash');
module.exports = /*@ngInject*/function ($scope, $location, $route, $filter, $uibModal, Upload, ProgramService, PartyService, ReportService, ConfigService) {
  var ctrl = this;
  ctrl.selectedProgram = undefined;
  ctrl.configurations = [];
  ctrl.memberToEdit = undefined;
  ctrl.responsiblePersonToEdit = undefined;
  ctrl.selectedMember = undefined;
  ctrl.selectedMemberFlag = false;
  ctrl.memberToAdd = undefined;
  ctrl.responsiblePersonToAdd = undefined;
  ctrl.partyPeople = undefined;
  ctrl.attributes = [];
  ctrl.partyToPeopleId = undefined;
  ctrl.party = undefined;
  ctrl.config = ConfigService.getConfig();
  ctrl.PROFILE_URL = ctrl.config.PROFILE_URL;
  ctrl.action = undefined;
  ctrl.uploading = false;
  ctrl.uploadErrorMessage = null;
  ctrl.readOnly = true;
  ctrl.syncPartyTypes = ['SHOP', 'GENLAB', 'LUA', 'BIO'];
  ctrl.selectPartyByProgram = function (program) {
    if (program._id) {
      ProgramService.getParties({
        id: program._id
      }).$promise.then(function (parties) {
        ctrl.parties = parties;
        ctrl.selectParty(parties[0]);
      });
    }
  };
  ctrl.syncCheck = function () {
    return ctrl.party && ctrl.party.sync && (ctrl.party.type.toUpperCase() === 'LAB' || ctrl.party.type.toUpperCase() === 'RUA' || ctrl.syncPartyTypes.includes(ctrl.party.type.toUpperCase()) && ctrl.party.campus === '01');
  };
  ctrl.selectParty = function (party) {
    ctrl.selectedMember = undefined;
    if (party) {
      ctrl.party = party;
    } else {
      $location.search('member', null).replace();
    }
    if (ctrl.party) {
      ctrl.readOnly = ctrl.syncCheck();
      ctrl.party.members = ctrl.sortPartyMembers();
      ctrl.initPartyMember();
      PartyService.getPartyPeopleBySource({
        sourceId: ctrl.party._id
      }).$promise.then(function (partyPeople) {
        ctrl.partyToPeopleId = partyPeople._id;
      });
    }
    if (ctrl.party) {
      ctrl.configurations = ctrl.selectedProgram.configurations.filter(function (configuration) {
        return configuration.party === ctrl.party._id;
      }) || [];
    }
  };
  ctrl.selectDefaultView = function (index, member) {
    if (index === 0 && !ctrl.selectedMemberFlag) {
      ctrl.selectPartyMember(member);
      ctrl.selectedMemberFlag = true;
    }
  };
  ctrl.addMember = function () {
    ctrl.resetEditMember();
    ctrl.action = 'ADD_MEMBER';
    ctrl.memberToAdd = PartyService.initializePartyMember();
  };
  ctrl.getAttributes = function (query) {
    return ctrl.party.attributes.filter(function (attribute) {
      return attribute.toLowerCase().indexOf(query.toLowerCase()) > -1;
    }).map(function (attribute) {
      return $filter('camelcase')(attribute);
    });
  };
  ctrl.initPartyMember = function () {
    if (ctrl.party) {
      if ($location.search().member) {
        ctrl.selectPartyMember(_.find(ctrl.party.members, function (item) {
          return item.id === $location.search().member;
        }));
      }
    }
  };
  ctrl.selectPersonToDelete = function (person) {
    // eslint-disable-next-line no-param-reassign
    ctrl.partyPeople.forEach(function (p) {
      return delete p.confirmDelete;
    });
    // eslint-disable-next-line no-param-reassign
    person.confirmDelete = true;
    ctrl.action = 'DELETE_PARTY_MEMBER';
  };
  ctrl.cancelAction = function () {
    // eslint-disable-next-line no-param-reassign
    ctrl.partyPeople.forEach(function (p) {
      return delete p.confirmDelete;
    });
    ctrl.resetResponsiblePerson();
    ctrl.action = undefined;
    ctrl.resetMember();
    delete ctrl.selectedMember.confirmDelete;
  };
  ctrl.selectPartyMember = function (member) {
    if (member) {
      ctrl.selectedMember = member;
      ctrl.renderPartyToPeople(member, ctrl.party._id);
      $location.search('member', member.id).replace();
      ReportService.getCountByParty({
        partyId: member.id
      }).$promise.then(function (result) {
        ctrl.reportCount = result.count;
      });
    }
  };
  ctrl.clearPartySearch = function () {
    ctrl.selectedMember = undefined;
    ctrl.partyPeople = [];
    $location.search('member', undefined).replace();
  };
  ctrl.renderPartyToPeople = function (member, partyId) {
    PartyService.getPeopleByPartyMemberAndSource({
      partyId: member.id,
      sourceId: partyId
    }).$promise.then(function (partyPeople) {
      ctrl.partyPeople = partyPeople || [];
    });
  };
  ctrl.actionOnMember = function (member, action) {
    ctrl.resetAddMember();
    ctrl.action = action;
    ctrl.memberToEdit = _.cloneDeep(member);
    ctrl.attributes = member.attributes.length > 0 ? _.map(member.attributes, function (attribute) {
      return $filter('camelcase')(attribute);
    }) : [];
  };
  ctrl.deleteMember = function (member) {
    var cloneMember = _.cloneDeep(member);
    delete cloneMember.confirmDelete;
    _.remove(ctrl.party.members, {
      id: member.id
    });
    ctrl.updatePartyMember(member, 'DELETE');
  };
  ctrl.resetMember = function () {
    ctrl.resetAddMember();
    ctrl.resetEditMember();
  };
  ctrl.resetAddMember = function () {
    ctrl.action = undefined;
    ctrl.memberToAdd = undefined;
    ctrl.attributes = [];
  };
  ctrl.resetEditMember = function () {
    ctrl.action = undefined;
    ctrl.memberToEdit = undefined;
    ctrl.attributes = [];
  };
  ctrl.save = function (isValid, editedMember) {
    if (isValid) {
      var index = _.findIndex(ctrl.party.members, {
        id: editedMember.id
      });
      if (index > -1) {
        ctrl.progress = true;
        ctrl.party.members[index] = editedMember;
        ctrl.selectedMember = editedMember;
        // eslint-disable-next-line no-param-reassign
        editedMember.attributes = ctrl.transformAttributes();
        ctrl.updatePartyMember(editedMember, 'UPDATE');
      }
    }
  };
  ctrl.uploadTemplate = function (file) {
    ctrl.uploading = true;
    var request = {
      method: 'POST',
      url: "api/party/".concat(ctrl.party._id, "/template/upload"),
      file: file
    };
    Upload.upload(request).then(function (result) {
      // eslint-disable-next-line no-use-before-define
      updatePartyAndParties(result.data);
      ctrl.uploading = false;
    })["catch"](function (error) {
      ctrl.uploading = false;
      ctrl.uploadErrorMessage = error.message;
    });
  };
  ctrl.add = function (isValid, member) {
    if (isValid) {
      // eslint-disable-next-line no-param-reassign
      member.attributes = ctrl.transformAttributes();
      ctrl.party.members.push(_.cloneDeep(member));
      ctrl.updatePartyMember(member, 'CREATE');
      ctrl.resetMember();
    }
  };
  ctrl.transformAttributes = function () {
    return ctrl.attributes.length > 0 ? _.map(ctrl.attributes, function (attribute) {
      return attribute.text.toUpperCase().replace(/\s/g, '_');
    }) : [];
  };
  function updatePartyAndParties(party) {
    // eslint-disable-next-line no-undef
    ctrl.party = angular.copy(party);
    ctrl.party.members = ctrl.sortPartyMembers();
    var matchParty = ctrl.parties.find(function (p) {
      return p._id === ctrl.party._id;
    });
    if (matchParty) {
      Object.assign(matchParty, ctrl.party);
    }
  }
  ctrl.rankMembers = function (viewValue) {
    var query = viewValue && viewValue.toLowerCase();
    return ctrl.party.members.map(function (member) {
      var name = member.name.toLowerCase();
      var desc = (member.description || '').toLowerCase();
      var score = 0;
      if (name === query) score += 100;else if (desc === query) score += 90;else if (name.startsWith(query)) score += 80;else if (desc.startsWith(query)) score += 70;else if (name.includes(query)) score += 60;else if (desc.includes(query)) score += 50;
      return {
        member: member,
        score: score
      };
    }).filter(function (r) {
      return r.score > 0;
    }).sort(function (a, b) {
      return b.score - a.score;
    }).map(function (r) {
      return r.member;
    });
  };
  ctrl.updatePartyMember = function (member, action) {
    ctrl.progress = true;
    // eslint-disable-next-line default-case
    switch (action) {
      case 'CREATE':
      case 'UPDATE':
        PartyService.updatePartyMember({
          id: ctrl.party._id,
          action: action
        }, member).$promise.then(function (result) {
          updatePartyAndParties(result);
          ctrl.selectedMember = member;
          ctrl.renderPartyToPeople(member, ctrl.party._id);
          $location.search('member', member.id).replace();
          ctrl.progress = false;
        });
        break;
      case 'DELETE':
        $uibModal.open({
          templateUrl: 'management/party/_party.delete.confirm.html',
          controllerAs: '$ctrl',
          backdrop: 'static',
          // eslint-disable-next-line func-names, object-shorthand
          controller: /*@ngInject*/function controller($uibModalInstance) {
            var $ctrl = this;
            $ctrl.message = ctrl.reportCount > 0 ? "There are ".concat(ctrl.reportCount, " inspections associated with this party. Are you sure you want to delete ?") : 'Are you sure you want to delete this party ?';
            $ctrl.ok = function () {
              PartyService.updatePartyMember({
                id: ctrl.party._id,
                action: action
              }, member).$promise.then(function (result) {
                updatePartyAndParties(result);
                ctrl.progress = false;
                ctrl.resetMember();
                $location.search('member', undefined);
                ctrl.selectedMember = undefined;
              });
              $uibModalInstance.dismiss('cancel');
            };
            $ctrl.cancel = function () {
              ctrl.progress = false;
              $uibModalInstance.dismiss('cancel');
            };
          }
        });
        break;
    }
  };
  ctrl.sortPartyMembers = function () {
    return _.sortBy(ctrl.party.members, [function (member) {
      return member.name.toLowerCase();
    }], ['name', 'description']);
  };
  ctrl.selectedResponsiblePerson = function (person) {
    var responsiblePerson = _.cloneDeep(person);
    if (!ctrl.findResponsiblePerson(responsiblePerson)) {
      ctrl.responsiblePersonToAdd = ctrl.buildResponsiblePerson(responsiblePerson);
    } else {
      ctrl.responsiblePersonExist = true;
    }
  };
  ctrl.findResponsiblePerson = function (person) {
    return _.some(ctrl.partyPeople, function (partyPerson) {
      return _.some(partyPerson.mappings, function () {
        return partyPerson.mappings.userId === person.userId;
      });
    });
  };
  ctrl.buildResponsiblePerson = function (responsiblePerson) {
    return {
      userId: responsiblePerson.userId,
      firstName: responsiblePerson.firstName,
      lastName: responsiblePerson.lastName,
      email: responsiblePerson.email,
      parties: [{
        id: ctrl.selectedMember.id,
        name: ctrl.selectedMember.name,
        type: 'MANAGER'
      }]
    };
  };
  ctrl.addResponsiblePerson = function (isValid, responsiblePerson) {
    if (isValid) {
      ctrl.updateResponsiblePerson(ctrl.partyToPeopleId, responsiblePerson, 'CREATE');
    }
  };
  ctrl.saveResponsiblePerson = function (isValid, responsiblePerson) {
    if (isValid) {
      ctrl.updateResponsiblePerson(responsiblePerson._id, responsiblePerson.mappings, 'UPDATE');
    }
  };
  ctrl.updateResponsiblePerson = function (partyPeopleId, mapping, action) {
    PartyService.updatePartyPeople({
      partyPeopleId: partyPeopleId,
      action: action
    }, mapping, function (result) {
      if (result.ok) {
        ctrl.deleteProgress = false;
        ctrl.action = undefined;
        ctrl.renderPartyToPeople(ctrl.selectedMember, ctrl.party._id);
        ctrl.resetResponsiblePerson();
      }
    });
  };
  ctrl.deleteResponsiblePerson = function (respPerson) {
    ctrl.deleteProgress = true;
    var responsiblePerson = _.cloneDeep(respPerson);
    delete responsiblePerson.confirmDelete;
    _.remove(responsiblePerson.mappings.parties, {
      id: ctrl.selectedMember.id
    });
    responsiblePerson.mappings.partyToRemoveId = ctrl.selectedMember.id;
    ctrl.updateResponsiblePerson(responsiblePerson._id, responsiblePerson.mappings, 'DELETE');
  };
  ctrl.resetResponsiblePerson = function () {
    ctrl.responsiblePersonToEdit = undefined;
    ctrl.responsiblePersonClicked = undefined;
    ctrl.responsiblePersonToAdd = undefined;
    ctrl.responsiblePerson = undefined;
    ctrl.responsiblePersonExist = undefined;
  };
  ctrl.selectProgram = function (program) {
    if (program._id) {
      ProgramService.get({
        id: program._id
      }, function (result) {
        ctrl.selectedProgram = result;
      });
    }
  };
  ctrl.editPartyDetails = function (party) {
    $uibModal.open({
      templateUrl: 'management/configuration/_party-form.html',
      controllerAs: '$ctrl',
      backdrop: 'static',
      // eslint-disable-next-line func-names, object-shorthand
      controller: /*@ngInject*/function controller($uibModalInstance) {
        var $ctrl = this;
        // eslint-disable-next-line prefer-object-spread
        $ctrl.party = Object.assign({}, party);
        PartyService.getAllPartyTypes().$promise.then(function (types) {
          $ctrl.partyList = types;
        })["catch"](function () {
          $ctrl.partyList = [];
        });

        // eslint-disable-next-line
        $ctrl.validate = function (field) {
          $ctrl['party-form'][field].$error.duplicate = _.some(ctrl.parties, function (p) {
            return _.toLower(p.name) === _.toLower($ctrl.party.name) && p._id !== $ctrl.party._id;
          });
          $ctrl['party-form'].$setValidity('duplicate', !$ctrl['party-form'][field].$error.duplicate, $ctrl['party-form'][field]);
        };

        // eslint-disable-next-line
        $ctrl.submit = function () {
          $ctrl.progress = true;
          PartyService.update({
            id: $ctrl.party._id
          }, $ctrl.party).$promise.then(function (updatedParty) {
            Object.assign(ctrl.party, updatedParty);
            $ctrl.cancel();
          });
        };
        // eslint-disable-next-line
        $ctrl.cancel = function () {
          $ctrl.progress = false;
          $uibModalInstance.dismiss('cancel');
        };
      }
    });
  };
  ctrl.initFirst = true;
  $scope.$watch(function () {
    return $location.search();
  }, function (newSearch, oldSearch) {
    if (newSearch.program !== oldSearch.program || ctrl.initFirst) {
      ctrl.selectedMember = undefined;
      ctrl.memberToEdit = undefined;
      ctrl.memberToAdd = undefined;
      ctrl.initFirst = false;
      ctrl.responsiblePersonClicked = false;
      ctrl.selectPartyByProgram({
        _id: $location.search().program
      });
      ctrl.selectProgram({
        _id: $location.search().program
      });
    }
  }, true);
};